import { Acknowledgements } from '@/components/acknowledgements';

const SettingsAcknowledgements = () => {
  return <Acknowledgements />;
};

export { SettingsAcknowledgements };
